import React from "react";
import './css/announcement.css'

export default function Announcement (){
    return(
        <div className="announcement">
            <h3 className="announcement-title">Announcements <img src="https://img.icons8.com/external-others-iconmarket/25/null/external-announcement-protest-others-iconmarket.png" alt="anouncement"/></h3>
            <h3>We are on adding Project and Internship Details, So just fill up profile only</h3>
        </div>
    )
}